<template>
  <ScrollAreaRoot v-bind="props">
    <ScrollAreaScrollbar
      class="peer/vertical flex touch-none select-none rounded-[10px] bg-navy/20 transition-colors duration-[160ms] ease-out data-[orientation=horizontal]:h-[3px] data-[orientation=vertical]:w-[3px] data-[orientation=horizontal]:flex-col"
      orientation="vertical"
    >
      <ScrollAreaThumb
        class="relative flex-1 rounded-[10px] bg-navy before:absolute before:left-1/2 before:top-1/2 before:h-full before:min-h-[44px] before:w-full before:min-w-[4px] before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"
      />
    </ScrollAreaScrollbar>
    <ScrollAreaScrollbar
      class="flex touch-none select-none rounded-[10px] bg-navy/20 transition-colors duration-[160ms] ease-out data-[orientation=horizontal]:h-[3px] data-[orientation=vertical]:w-[3px] data-[orientation=horizontal]:flex-col"
      orientation="horizontal"
    >
      <ScrollAreaThumb
        class="relative flex-1 rounded-[10px] bg-navy before:absolute before:left-1/2 before:top-1/2 before:h-full before:min-h-[44px] before:w-full before:min-w-[44px] before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"
      />
    </ScrollAreaScrollbar>
    <ScrollAreaViewport
      v-bind="$attrs"
      class="peer-data-[state]/vertical:pr-1.5"
    >
      <slot />
    </ScrollAreaViewport>
  </ScrollAreaRoot>
</template>

<script setup lang="ts">
import {
  ScrollAreaRoot,
  ScrollAreaScrollbar,
  ScrollAreaThumb,
  ScrollAreaViewport,
  type ScrollAreaRootProps,
} from "radix-vue";

defineOptions({ inheritAttrs: false });

const props = withDefaults(defineProps<ScrollAreaRootProps>(), {
  type: "auto",
});
</script>
